

    /**
     * Checks if the value is created by the `Object` constructor.
     */
    function isPlainObject(value) {
        return (!!value && typeof value === 'object' &&
            value.constructor === Object);
    }

    module.exports = isPlainObject;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/lang/isPlainObject.js
// module id = 1080
// module chunks = 6